import React from 'react';
import PropTypes from 'prop-types';
import { branch, renderNothing } from 'recompose';
import UpgradePackage from './UpgradePackage';
import classNames from 'classnames';
import styles from './Upgrade.scss';

function Upgrade({ services }) {
  return (
    <div>
      <h3 className={styles.title}>Available upgrades</h3>
      <section
        className={classNames(styles.upgrade, {
                    [styles.oneService]: services.slice(0, 3).length === 1,
                    [styles.twoServices]: services.slice(0, 3).length === 2,
                    [styles.threeServices]: services.slice(0, 3).length === 3,
                })}
            >
        {services.slice(0, 3).map(service => (
          <UpgradePackage data={service} />
                ))}
      </section>
    </div>
  );
}

Upgrade.defaultProps = {
  services: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.string),
    priceId: PropTypes.number,
    price: PropTypes.string,
    pricePerMonth: PropTypes.string,
    period: 1,
    periodUnit: PropTypes.string,
  })).isRequired,
  expired: PropTypes.bool.isRequired,
  needUpgrade: PropTypes.bool.isRequired,
};

export default branch(props => props.expired || !props.needUpgrade, renderNothing)(Upgrade);
